import React from "react";
import { connect } from "react-redux";
import { getSSWP, getJobPackReportsSSWP } from "./actions";
import { selectSSWP } from "./selectors";

import levels from "./levels";
import {
    Card,
    CardContent,
    TextField,
    MenuItem,
    Select,
    Typography
} from "@material-ui/core";
import { StyledHeader } from "../../styles";
import PrintIcon from "@material-ui/icons/Print";
import { cellStyle as cs } from "../gridHelper";
import MapContainer from "../MapContainer";
import { gridStyle as gstyle, cellStyle as cstyle } from "../gridHelper";
import ReactToPrint from "react-to-print";
import data from "./data";
import "./CustomSSWP.css";

class SSWP extends React.Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");

        this.state = {
            report: false,
            editing:
                path[1] === "report-view"
                    ? false
                    : path[1] === "report-view-standalone"
                    ? false
                    : true,

            title: document.title,
        };
        if (path[2] === "reports") {
            props.getSSWP(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":")
            );
        } else {
            props.getJobPackReportsSSWP(
                props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    componentDidMount() {
        setTimeout(() => {
            let naClass = document.getElementsByClassName("customList");
            for (var i = 0; i < naClass.length; i++) {
                if (naClass[i].innerHTML === "")
                    naClass[i].parentElement.style.cssText += "display:none;";
            }
        }, 1000);
    }

    renderText = (key) => {
        if (this.state.editing) {
            return (
                <TextField
                    style={{ width: "100%" }}
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({
                            report,
                        });
                    }}
                />
            );
        } else {
            return this.state.report[key];
        }
    };

    renderDropDown = (key, opts) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === ""
                            ? "N/A"
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value="N/A">N/A</MenuItem>
                    {opts.map((option) => {
                        return (
                            <MenuItem value={option} key={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            );
        } else {
            return this.state.report[key] === ""
                ? "NA"
                : this.state.report[key];
        }
    };
    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cstyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    renderSigs(attachedPhotos) {
        let photoRow = 3;
        let photoCell = 1;
        let ref = "";
        return attachedPhotos.map((photo, i) => {
            if (photo.signature_url.includes("https:") === false) {
                ref = "data:image/png;base64," + photo.signature_url;
            }
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.signature_name}
                    </div>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.signature_timestamp}
                    </div>
                    {photo.signature_url.includes("https:") ? (
                        <div
                            style={cstyle(
                                photoRow + 1,
                                photoCell,
                                photoRow + 1,
                                photoCell + 2
                            )}
                        >
                            <img
                                src={photo.signature_url}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: photo,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    ) : (
                        <div
                            style={cstyle(
                                photoRow + 1,
                                photoCell,
                                photoRow + 1,
                                photoCell + 2
                            )}
                        >
                            <img
                                src={ref}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: photo,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    )}
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    render() {
        const { report } = this.state;
        const dp = this.renderDropDown;
        // const rt = this.renderText;
        let color = this.props.color;
        return (
            <>
                <Card>
                    <StyledHeader style={{ background: "#0188cc" }}>
                        <Typography variant="h5" style={{ color: "white" }}>
                            SSWP
                            <ReactToPrint
                                onBeforePrint={() =>
                                    (document.title =
                                        "SSWP" +
                                        this.props.match.params.report_id)
                                }
                                onAfterPrint={() =>
                                    (document.title = this.state.title)
                                }
                                trigger={() => (
                                    <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor:"pointer"
                                    }}
                                    />
                                )}
                                content={() => this.componentRef}
                            />
                        </Typography>
                    </StyledHeader>
                    <CardContent>
                        {report && (
                            <div ref={(el) => (this.componentRef = el)}>
                                {this.props.header && (
                                    <this.props.header
                                        date={this.props.match.params.report_id}
                                        reportType={this.props.reportType}
                                    />
                                )}
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={{ width: "50%", float: "left" }}
                                    >
                                        <div style={gstyle(7, 13, null, color)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Information</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 13)}>
                                                <b>Name:</b>&nbsp;      {report.user_name
                                                    ? report.user_name
                                                    : "N/A"}
                                            </div>
                                
                                            <div style={cstyle(3, 1, 3, 13)}>
                                                <b>Email:</b>&nbsp;   {report.user_email
                                                    ? report.user_email
                                                    : "N/A"}
                                            </div>
                                  
                                            <div style={cstyle(4, 1, 4, 13)}>
                                                <b>Timestamp: </b>&nbsp;  {report.timestamp
                                                    ? report.timestamp
                                                    : "N/A"}
                                            </div>
                             
                                            <div style={cstyle(5, 1, 5, 13)}>
                                                <b>Client Name: </b>&nbsp;    {report.client_name
                                                    ? report.client_name
                                                    : "N/A"}
                                            </div>
                                   
                                            <div style={cstyle(6, 1, 6, 13)}>
                                                <b>Contract No: </b>&nbsp;  {report.contract_number
                                                    ? report.contract_number
                                                    : "N/A"}
                                            </div>
                                        
                                            <div style={cstyle(7, 1, 7, 13)}>
                                                <b>Start Date: </b>&nbsp;  {report.start_date
                                                    ? report.start_date
                                                    : "N/A"}
                                            </div>
                                     
                                            <div style={cstyle(8, 1, 8, 13)}>
                                                <b>Task Name: </b>&nbsp;    {report.task_name
                                                    ? report.task_name
                                                    : "N/A"}
                                            </div>
                                      
                                            <div style={cstyle(9, 1, 9, 13)}>
                                                <b>No of Worker: </b>&nbsp; {report.no_of_worker
                                                    ? report.no_of_worker
                                                    : "N/A"}
                                            </div>
                                       
                                            <div style={cstyle(10, 1, 10, 13)}>
                                                <b>Job Address: </b>&nbsp;  {report.exact_location
                                                    ? report.exact_location
                                                    : "N/A"}
                                            </div>
                                       
                                            <div style={cstyle(11, 1, 11, 13)}>
                                                <b>Responsible report: </b>&nbsp;  {report.responsible_person
                                                    ? report.responsible_person
                                                    : "N/A"}
                                            </div>
                                           
                                            <div style={cstyle(12, 1, 12, 13)}>
                                                <b>Description of Works: </b>&nbsp;  {report.description
                                                    ? report.description
                                                    : "N/A"}
                                            </div>
                                        
                                            <div style={cstyle(13, 1, 13, 13)}>
                                                <b>SSWP Template: </b>&nbsp;   {report.sswp_config_uid
                                                    ? report.sswp_config_uid
                                                    : "N/A"}
                                            </div>
                                         
                                            <div style={cstyle(14, 1, 14, 13)}>
                                                <b>Job Name: </b>&nbsp;  {report.job_name
                                                    ? report.job_name
                                                    : "N/A"}
                                            </div>
                                
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "48%",
                                            float: "left",
                                            marginLeft: "2%",
                                        }}
                                    >
                                        <MapContainer
                                            lat={+report.location_lat}
                                            long={+report.location_lon}
                                            style={{
                                                width: "80%",
                                                height: "100%",
                                            }}
                                        />
                                        <br />
                                        <br />
                                    </div>
                                </div>
                                <div style={{ width: "100%", clear: "both" }}>
                                    {Object.keys(data).map((category) => {
                                        return (
                                            <div>
                                                <div
                                                    style={{
                                                        ...cs(
                                                            1,
                                                            1,
                                                            1,
                                                            5,
                                                            false,
                                                            true
                                                        ),

                                                        position: "relative",
                                                        backgroundColor:
                                                            report[
                                                                levels[category]
                                                            ] === "HIGH"
                                                                ? "red"
                                                                : report[
                                                                      levels[
                                                                          category
                                                                      ]
                                                                  ] === "MED"
                                                                ? "orange"
                                                                : "green",
                                                    }}
                                                >
                                                    <b>{category}</b>
                                                    <b
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            top: 12,
                                                            right: 12,
                                                        }}
                                                    >
                                                        {
                                                            report[
                                                                levels[category]
                                                            ]
                                                        }
                                                    </b>
                                                </div>

                                                <ul
                                                    className="customList"
                                                    style={{
                                                        padding: "0",
                                                        marginTop: "0",
                                                        marginBottom: "0rem",
                                                    }}
                                                >
                                                    {data[category].map(
                                                        (control) => {
                                                            if (
                                                                report[
                                                                    control.key
                                                                ] === "Yes"
                                                            )
                                                                return (
                                                                    <li
                                                                        className={dp(
                                                                            control.key,
                                                                            [
                                                                                "No",
                                                                                "Yes",
                                                                            ]
                                                                        )}
                                                                    >
                                                                        <div>
                                                                            <img
                                                                                alt={
                                                                                    control.key
                                                                                }
                                                                                src={
                                                                                    control.icon
                                                                                }
                                                                                style={{
                                                                                    height:
                                                                                        "100px",
                                                                                    margin:
                                                                                        "auto",
                                                                                    display:
                                                                                        "block",
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            className={
                                                                                dp(
                                                                                    control.key,
                                                                                    [
                                                                                        "No",
                                                                                        "Yes",
                                                                                    ]
                                                                                ) +
                                                                                " text-center"
                                                                            }
                                                                        ></div>
                                                                    </li>
                                                                );
                                                            else return null;
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        );
                                    })}
                                    <div style={gstyle(4, 9, null)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                1,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Attached Photos</b>
                                        </div>
                                        {report.attached_photos &&
                                            this.renderPhotos(
                                                report.attached_photos
                                            )}
                                    </div>
                                    <div style={gstyle(4, 9, null)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                1,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Attached Signatures</b>
                                        </div>
                                        {report.attached_signatures &&
                                            this.renderSigs(
                                                report.attached_signatures
                                            )}
                                    </div>
                                </div>
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Thumbs Up Photos</b>
                                    </div>
                                    {report.attached_thumbsup_photos &&
                                        this.renderPhotos(
                                            report.attached_thumbsup_photos
                                        )}
                                </div>
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Last Induction Location Details</b>
                                    </div>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Last Induction Location Details</b>
                                    </div>

                                    <div style={cstyle(2, 1, 2, 1, true)}>
                                        <b>Latitude</b> &nbsp;{" "}
                                        {report.last_induction_location_lat}
                                    </div>

                                    <div style={cstyle(2, 2, 2, 2, true)}>
                                        <b>Longitude</b> &nbsp;{" "}
                                        {report.last_induction_location_lon}
                                    </div>

                                    <div style={cstyle(3, 1, 3, 3, true)}>
                                        <div
                                            style={{
                                                width: "30%",
                                                float: "left",
                                                marginLeft: "35%",
                                                height: "300px",
                                            }}
                                        >
                                            <MapContainer
                                                lat={
                                                    +report.last_induction_location_lat
                                                }
                                                long={
                                                    +report.last_induction_location_lon
                                                }
                                                style={{ width: "80%" }}
                                            />
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </>
        );
    }
}

export default connect(
    (store) => {
        return { report: selectSSWP(store) };
    },
    { getSSWP, getJobPackReportsSSWP }
)(SSWP);
